'use strict';
/* global angular */

import extend from 'lodash/extend';
import template from '../../templates/authentication-dialog.html';

angular.module('atex.aceui.authentication').factory('AuthenticationDialog',
  ['$rootScope', '$location', '$window', '$q', '$translate', '$uibModal', 'Application', 'AuthenticationService',

    function ($rootScope, $location, $window, $q, $translate, $uibModal, Application, AuthenticationService) {
      return {
      /**
       * Creates a new authentication dialog, using the provided parameters.
       *
       * Argument 'params' - A parameter object containing values used by the
       * authentication dialog. Merged with the default parameters, which
       * look like this:
       *
       * {
       *   autoDestroy: true,
       *   message: 'You are required to log in. Please enter your credentials:',
       *   username: undefined
       * }
       *
       * Property 'autoDestroy' determines whether the authentication dialog
       * should be automatically destroyed when the authentication process is
       * complete.
       *
       * Property 'message' contains the message shown in the authentication dialog.
       *
       * Property 'username' contains the username that should be pre-filled in
       * the authentication dialog. If this property is defined, the authentication
       * dialog will automatically be set to 'confirm' mode instead of login mode.
       *
       * Returns an object that looks like this:
       *
       * {
       *   whenAuthenticated: function() {
       *     // ...
       *   },
       *
       *   destroy: function() {
       *     // ...
       *   }
       * }
       *
       * The 'whenAuthenticated' property returns a Q-based promise that will be resolved
       * when the authentication process is completed.
       *
       * The 'destroy' property is a function that can be used to destroy the authentication
       * modal. Typically used with 'autoDestroy' property in the input parameters set to false.
       */
        create: function (params) {
          var defaultParams = {
            autoDestroy: true,
            message: undefined,
            username: undefined
          };

          var authenticationArgs = extend({}, defaultParams, params),
            onAuthenticatedDeferred = $q.defer(),
            authScope = $rootScope.$new(true);

          authScope.mode = authenticationArgs.username === undefined ? 'authenticate' : 'confirm';
          authScope.message = authenticationArgs.message;

          authScope.usernameInput = { value: authenticationArgs.username };

          authScope.passwordInput = { value: '' };

          authScope.busy = false;

          var modal = $uibModal.open({
            scope: authScope,
            template,
            windowClass: 'login-modal',
            backdrop: 'static',
            keyboard: false
          });

          authScope.authenticate = function () {
            if (!(authScope.usernameInput.value.length > 0 && authScope.passwordInput.value.length > 0) || authScope.busy) {
              return false;
            }

            authScope.busy = true;

            AuthenticationService.login ({ username: authScope.usernameInput.value, password: authScope.passwordInput.value})
              .then (function (user) {
                authScope.errorMessage = undefined;

                if (authenticationArgs.autoDestroy) {
                  modal.close();
                }

                onAuthenticatedDeferred.resolve(user);
              }, function (error) {
                if (error.type === atex.aceui.error.types.AUTHENTICATION_FAILED) {
                  authScope.errorMessage = 'ace-ui.auth.msg.invalid-login';
                } else {
                  authScope.errorMessage = 'ace-ui.auth.msg.error-login';
                }

                authScope.busy = false;
              });

            return false;
          };

          authScope.switchUser = function () {
            AuthenticationService.logout();
          };

          authScope.cancel = function () {
            if (authScope.busy) {
              return false;
            }

            authScope.busy = true;

            if (authenticationArgs.autoDestroy) {
              modal.close();
            }

            onAuthenticatedDeferred.reject();

            return false;
          };

          return {
            whenAuthenticated: function () {
              return onAuthenticatedDeferred.promise;
            },

            destroy: function () {
              modal.close();
            }
          };
        }
      };
    }
  ]);
